module.exports = __webpack_public_path__ + "img/ltkfamily-3x.16bdeeb.jpg";